module.exports = __webpack_public_path__ + "assets/src/images/SunrunHawaiiSolarHome.jpg";